import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  Self,
  Optional,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from "@angular/core";
import IMask from "imask";
import { NgModel } from '@angular/forms';
import {Subscription} from 'rxjs';

@Directive({
  selector: '[EKVNummerMask]'
})
export class EKVNummerMaskDirective implements AfterViewInit, OnChanges {
  private mask: InstanceType<typeof IMask.InputMask> | null = null;

  constructor(private el: ElementRef<HTMLInputElement>,@Self() @Optional() private ngModel: NgModel) {
  }

  ngOnChanges(changes: SimpleChanges): void {
       if(changes["vNummerType"])
       {
         this.SetMask();
       }
    }
  @Input('EKVNummerMask') vNummerType: VNummerType = VNummerType.GKV;
  ngAfterViewInit() {

    this.SetMask();
  }



  SetMask(){

    if(this.mask)
      this.mask.destroy();

    try {

      this.el.nativeElement.value =  '';

      if(this.vNummerType === VNummerType.GKV) {
        if (this.el.nativeElement instanceof HTMLInputElement)
          this.mask = IMask(this.el.nativeElement, {
            // The mask string: 1 custom character 'X' and 9 standard digits '0'
            mask: 'X000000000',
            prepareChar: str => str?.toUpperCase() ?? '',
            lazy: false,
            definitions: {
              // Define 'X' as a single Uppercase Letter via Regex
              'X': {
                mask: /^[A-Z]$/,
                // Optional: automatically convert lowercase to uppercase as they type
                prepare: (str: string) => str?.toUpperCase() ?? ``
              }
            }
          });
      }
      else if(this.vNummerType === VNummerType.Company)
      {
        if (this.el.nativeElement instanceof HTMLInputElement)
          this.mask = IMask(this.el.nativeElement, {
            // The mask string: 1 custom character 'X' and 9 standard digits '0'
            mask: '{CO}XX00000000',
            prepareChar: str => str?.toUpperCase() ?? '',
            lazy: false,
            definitions: {
              // Define 'X' as a single Uppercase Letter via Regex
              'X': {
                mask: /^[A-Z]$/,
                // Optional: automatically convert lowercase to uppercase as they type
                prepare: (str: string) => str?.toUpperCase() ?? ``
              }
            }
          });
      }
      else if(this.vNummerType === VNummerType.PKV)
      {
        if (this.el.nativeElement instanceof HTMLInputElement)
          this.mask = IMask(this.el.nativeElement, {
            // The mask string: 1 custom character 'X' and 9 standard digits '0'
            mask: '{PKV}XX00000000',
            prepareChar: str => str?.toUpperCase() ?? '',
            lazy: false,
            definitions: {
              // Define 'X' as a single Uppercase Letter via Regex
              'X': {
                mask: /^[A-Z]$/,
                // Optional: automatically convert lowercase to uppercase as they type
                prepare: (str: string) => str?.toUpperCase() ?? ``
              }
            }
          });
      }
      else if(this.vNummerType === VNummerType.All)
      {
        if (this.el.nativeElement instanceof HTMLInputElement)
          this.mask = IMask(this.el.nativeElement, {
            // The mask string: 1 custom character 'X' and 9 standard digits '0'
            mask: 'X####00000[000]',
            prepareChar: str => str?.toUpperCase() ?? '',
            lazy: false,
            definitions: {
              // Define 'X' as a single Uppercase Letter via Regex
              '#':{
                mask: /^[A-Z0-9]$/,
                prepare: (str: string) => str?.toUpperCase() ?? ``
              },
              'X': {
                mask: /^[A-Z]$/,
                // Optional: automatically convert lowercase to uppercase as they type
                prepare: (str: string) => str?.toUpperCase() ?? ``
              }
            }
          });
      }
    }catch (e) {
      debugger;
      console.log(e);
    }

  }

  @HostListener('input')
  onInput() {
    if (this.mask) {
      this.mask.updateValue();
    }
  }

}

export enum VNummerType {
  PKV, GKV, Company, All
}
